import { BetSlipHelper } from "app/helpers/betSlipHelper";
import { marketPeriodHelper } from "app/helpers/marketPeriodHelper";
import type {
  EventMarketType,
  EventRunnerType,
  EventType,
} from "app/types/eventType";
import { Component } from "react";
import { connect } from "react-redux";
import RenderOddsComponent from "../RenderOddsComponent/RenderOddsComponent";
import "./SingleRowMarketRunnerDetails.scss";
type Props = {
  event: EventType;
  market: EventMarketType;
  marketType: Record<string, any>;
  addBetSlip: (...args: Array<any>) => any;
}; //

class SingleRowMarketRunnerDetails extends Component<Props> {
  addBetSlip = (runner: EventRunnerType) => {
    let betSlip = BetSlipHelper.prepareBetSlip(this.props.event, runner);
    this.props.addBetSlip(betSlip);
  };

  render() {
    const { event, market, marketType } = this.props;
    return (
      <div className={"market single-row-market"}>
        {market.runners.map(runner => {
          if (marketPeriodHelper.shouldHideRunner(runner)) {
            return (
              <span
                key={"single-row" + runner.id}
                className="single-row-market__runner--empty"
              ></span>
            );
          }

          return (
            <span
              key={"single-row" + runner.id}
              onClick={() => {
                this.addBetSlip(runner);
              }}
              className={`single-row-market__runner`}
            >
              <div className="runner__name">{runner.name}</div>
              <RenderOddsComponent
                event={event}
                runner={runner}
                marketType={marketType}
              />
            </span>
          );
        })}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addBetSlip: (betSlip: EventType) =>
      dispatch.betSlipListModel.addBetSlip(betSlip),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(SingleRowMarketRunnerDetails) as any;
